<template>
  <div>

    <div class="bar_nav">
      <div class="title">编辑群组名</div>
      <div class="bar_back_btn" @click="goToGroupHome">返回</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="名称" placeholder="请输入群组名" type="text" v-model="group.name" />
      <div class="btn_large" @click="save">确定</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EditGroupName',
  data: function () {
    return {
      group: ''
    }
  },
  async created() {
    try {
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
    } catch (err) {
      this.$faLoggr.error('EditGroupName.vue:created', err)
    }
  },
  methods: {
    async save() {
      try {
        await this.$faApi.updateGroup(this.$route.params.groupId, {
          name: this.group.name
        })
        this.$router.push({ path: `/group/${this.$route.params.groupId}` })
      } catch (err) {
        this.$faLoggr.error('EditGroupName.vue:goToGroupHome', err)
      }
    },
    async goToGroupSetting() {
      this.$router.push({ path: `/group/${this.group.id}/setting` })
    },
    goToGroupHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}` })
    }
  }
}
</script>

<style scoped lang="scss">
  .nav_bar {
    margin-top: 20px;
  }
</style>
  